import { Action } from 'redux';

import { NOTIFICATIONS_CLOSE_TYPE } from '../../constants/actionTypes';

export type TNotificationsCloseType = 'notifications/close';

export interface INotificationCloseType extends Action<TNotificationsCloseType> {
  type: TNotificationsCloseType;
}

export function close(): INotificationCloseType {
  return {
    type: NOTIFICATIONS_CLOSE_TYPE,
  };
}
